exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods .container .tip[data-v-1fc8ce04]{color:#aaa}.goods .container .el-radio-group[data-v-1fc8ce04]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.goods .container .el-radio-group .goods-show-type[data-v-1fc8ce04]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
